module.exports = __webpack_public_path__ + "img/touxiang.a3295be2.png";